import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';

type LoyaltyLoaderContainerProps = BoxProps & {
  width?: number;
};

const styles = StyleSheet.create({
  loyaltyLoaderContainer: {
    alignSelf: 'center',
    height: '100%',
    justifyContent: 'center',
    minHeight: 300,
    position: 'absolute',
  },
});

export const LoyaltyLoaderContainer = ({ style, width, ...props }: LoyaltyLoaderContainerProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.loyaltyLoaderContainer, width !== undefined && { width }, style],
  });
